import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessagesSquare, ClipboardList, Mail, BookHeart } from "lucide-react";
import { api } from "@/lib/api";
import { AdminTitle } from "./ui";

function Stat({ to, icon: Icon, label, value, sub, testid }) {
  return (
    <Link to={to} className="card p-6 transition-transform hover:-translate-y-0.5" data-testid={testid}>
      <Icon className="h-7 w-7 text-u" aria-hidden="true" />
      <p className="mt-4 font-display text-5xl font-bold text-ink">{value ?? "–"}</p>
      <p className="font-display text-lg font-semibold uppercase text-neutral-700">{label}</p>
      {sub && <p className="mt-1 text-sm text-neutral-500">{sub}</p>}
    </Link>
  );
}

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  const a = s?.applications || {};
  return (
    <div data-testid="admin-dashboard">
      <AdminTitle title="Tableau de bord" />
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
        <Stat to="/admin/messages" icon={MessagesSquare} label="Messages" value={s?.messages_total} sub={s && `${s.messages_new} nouveau(x) · ${s.messages_unread} non lu(s)`} testid="stat-messages" />
        <Stat to="/admin/candidatures" icon={ClipboardList} label="Candidatures" value={s?.applications_total}
          sub={s && `${a.partenaire} partenaires · ${a.benevole} bénévoles · ${a.formation} formations · ${a.don} dons`} testid="stat-applications" />
        <Stat to="/admin/newsletter" icon={Mail} label="Newsletter" value={s?.newsletter} sub="inscrits" testid="stat-newsletter" />
        <Stat to="/admin/livre-dor" icon={BookHeart} label="Livre d'or" value={s?.guestbook_pending} sub="en attente de modération" testid="stat-guestbook" />
      </div>
    </div>
  );
}
